import { render, staticRenderFns } from "./payrollreview.vue?vue&type=template&id=42f292fa&scoped=true"
import script from "./payrollreview.vue?vue&type=script&lang=js"
export * from "./payrollreview.vue?vue&type=script&lang=js"
import style0 from "./payrollreview.vue?vue&type=style&index=0&id=42f292fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f292fa",
  null
  
)

export default component.exports